import { axiosAPI } from '@/plugins/axios';

export function loadLanguageList() {
  return axiosAPI.get('/presets/languages ');
}

export const updateCoverImageByVideoKey = (key, payload) => axiosAPI.put(`videos/${key}/cover-image`, payload);
